/**
 * STARSEED-CAPMARKETS-069 — derive the founding-member join-fee waiver from
 * data the `/membership-fees/me` endpoint already returns.
 *
 * The endpoint's `registration.amount` is the GLOBAL standard fee
 * (`system_settings.registration_fee`, default $999) and carries no per-user
 * waiver signal (apps/capital-markets-api/routes/membership_fees.py:151).
 * But every founding-member registration writes a `membership_payments`
 * ledger row with `is_pioneer: true` and `fee_type: "registration+first_month"`
 * — both the Stripe-paid path (paid_registration.py:724-732) and the
 * STARSEED-CAPMARKETS-067 deferred path (paid_registration.py:495-512) — and
 * those rows come back verbatim in `history`. So the client can derive
 * "join fee waived" without any new API surface.
 */

/** True when the member's $999 join fee was waived (founding-member / pioneer
 *  registration). Derived from the payment-history rows. */
export function isJoinFeeWaived(data) {
  if (!data) return false;
  const history = Array.isArray(data.history) ? data.history : [];
  return history.some(
    (h) =>
      Boolean(h?.is_pioneer) &&
      String(h?.fee_type || "").toLowerCase().startsWith("registration")
  );
}

/** True when there is no outstanding registration fee blocking the member —
 *  either it was paid, or it was waived at registration. */
export function isRegistrationSettled(data) {
  if (!data) return false;
  return Boolean(data.registration?.paid) || isJoinFeeWaived(data);
}
